<div class="doctor_data" [formGroup]="medicoForm">
  <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
    <p class="section-title" style="margin: 0;"><strong>{{ 'Dados do médico' | translate }}</strong></p>
    <label *ngIf="!isValidMed()" style="cursor: pointer; display: flex; align-items: center; justify-content: flex-start; font-weight: bold; color: #4caf50; font-size: 0.85em;">
      <input type="checkbox" tabindex="-1" style="transform: scale(1); cursor: pointer; width: auto; margin: 0 6px 0 2px;" [checked]="isMedicoVerificadoChecked" (change)="onMedicoValidadoChange($event)" /> {{ 'Médico não encontrado na pesquisa.' | translate }}
    </label>
  </div>

    <div class="flex gap-1" style="width: 100%;">
      <div class="doctor_data__nome">
        <label><strong>{{ 'Nome' | translate }}:</strong></label>
        <input type="text" formControlName="nome" tabindex="-1" class="doctor-input" [placeholder]="'Nome do Médico' | translate" readonly />
      </div>
      <div class="doctor_data__email">
        <label><strong>{{ 'E-mail' | translate }}:</strong></label>
        <input type="email" formControlName="email" tabindex="-1" class="doctor-input" [placeholder]="'E-mail' | translate" readonly />
      </div>
    </div>

    <!-- Campos de entrada originais -->
    <div class="flex gap-1">
      <div class="institution_data__nome">
        <label><strong>{{ 'CRM' | translate }}:</strong></label>
        <input type="text" formControlName="matricula" tabindex="-1" class="doctor-input" [placeholder]="'CRM' | translate" readonly />
      </div>
       <div class="institution_data__nome" *ngFor="let esp of especialidadeArray.controls | slice:0:4; let j = index">
          <label><strong>{{ 'Especialidade' | translate}} {{j + 1}}:</strong></label>

          <ng-container *ngIf="isSmartCase; else medicoEspecialidadeInput">
            <input type="text" [formControl]="esp" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="especialidade_size" (keyup)="verificarAtalho($event, j)" appClearOnAltD appSmartCase readonly #especialidadeInput />
          </ng-container>
          <ng-template #medicoEspecialidadeInput>
            <input type="text" [formControl]="esp" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="especialidade_size" (keyup)="verificarAtalho($event, j)" appClearOnAltD appLowercaseOnChange readonly #especialidadeInput />
            <!-- [matAutocomplete]="autoEspecialidade" -->
          </ng-template>
          
          <!-- <button type="button" class="addRemoveButton" (click)="removeEspecialidade(j)" *ngIf="j>=1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          </button> -->
          <mat-autocomplete #autoEspecialidade="matAutocomplete">
            <mat-option *ngFor="let espItem of especialidadeFiltrado | slice:0:5" [value]="espItem">
              {{ espItem | lowercaseCustom }}
            </mat-option>
            <mat-option *ngIf="especialidadeFiltrado.length === 0" disabled>
              {{ 'Sem sugestões' | translate}}
            </mat-option>
          </mat-autocomplete>
      </div>
      <!-- <div class="">
          <button type="button"  class="addRemoveButton buttonSpecial" (click)="addEspecialidade()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          </button>
      </div> -->
    </div>
      <div class="institution_data__nome">
        <label><strong>{{ 'Rua' | translate }}:</strong></label>
        <input type="text" formControlName="rua" tabindex="-1" class="doctor-input" [placeholder]="'Endereço' | translate" readonly />
      </div>
    <div class="flex gap-1" style="width: 100%;">
      <div class="institution_data__nome">
        <label><strong>{{ 'Cidade' | translate}}:</strong></label>
        <ng-container *ngIf="isSmartCase; else medicoLocalidadeInput">
          <input type="text" formControlName="localidade" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="local_size" appClearOnAltD appSmartCase readonly />
        </ng-container>
        <ng-template #medicoLocalidadeInput>
          <input type="text" formControlName="localidade" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="local_size" appClearOnAltD  appLowercaseOnChange readonly />
        </ng-template>
      </div>
      <div class="institution_data__nome">
        <div formArrayName="telefone" class="flex gap-1">
          <div *ngFor="let tel of telefoneArray.controls | slice:0:2; let j = index">
            <label><strong>{{ 'Telefone' | translate }} {{j + 1}}:</strong></label>
            <ng-container *ngIf="isSmartCase; else medicoTelefoneInput">
              <input [formControl]="tel" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="phone_size" appClearOnAltD appSmartCase readonly />
            </ng-container>
            <ng-template #medicoTelefoneInput>
              <input [formControl]="tel" tabindex="-1" (keypress)="validarEntrada.emit($event)" class="phone_size" appClearOnAltD appLowercaseOnChange readonly />
            </ng-template>
            <!--button type="button" class="addRemoveButton" (click)="removeMedicoTelefone(j)" *ngIf="j>=1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            </button-->
          </div>
          <!--div class="">
            <button type="button"  class="addRemoveButton buttonSpecial" (click)="addMedicoTelefone()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            </button>
          </div-->
        </div>
    </div>
  </div>

  <!-- Bloco de Status e Retorno (Padronizado com o Produto) -->
  <div class="flex gap-1 status-row" [ngClass]="getMedStatusClass()" *ngIf="getMedStatus()"
    style="margin-top: 10px; padding: 10px; border-radius: 4px; align-items: center; width: 94%;">
    <span class="status-text" style="min-width: 80px; font-weight: bold; font-size: 1.05em;">{{ getMedStatus() | translate }}</span>

    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; flex: 1;">
      <!-- Nome do Médico (única linha) -->
      <ng-container *ngIf="isAmbiguousMed() && !isMedicoInsercaoManualAtiva">
        <div style="grid-column: span 3; display: flex; width: 100%;">
          <select formControlName="retorno_med" #retornoMedSelect id="retorno_med_select" class="review-input" [class.field-incomplete]="mostrarPendencias && !campoValido" (change)="onMedicoRetornoChange($event)" (keydown.enter)="abrirModalMedicoEnter($event)"
            style="flex: 1; width: auto;">
            <option value="" disabled selected>{{ 'Selecione o médico' | translate }}</option>
            <option *ngFor="let m of medicoForm.get('ConteudoMedFiltro')?.value" [value]="m.NOMBRE_MEDICO">{{
              m.NOMBRE_MEDICO }}</option>
          </select>
          <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalMedico(true)" [title]="'Pesquisar médico' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
          <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="ativarEntradaManualMedico()" [title]="'Inserir manualmente' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="isValidMed() || isNotFoundMed() || (isAmbiguousMed() && isMedicoInsercaoManualAtiva)">
        <div style="grid-column: span 3; display: flex; width: 100%;">
          <input type="text" formControlName="retorno_med" #retornoMedInput id="retorno_med_input" class="review-input" [class.field-incomplete]="mostrarPendencias && !campoValido" style="flex: 1; width: auto;" (keydown.shift.o)="abrirModalMedicoSpace($event)" (keydown.enter)="abrirModalMedicoEnter($event)" (input)="onRetornoMedInput()" />
          <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalMedico(true)" [title]="'Pesquisar médico' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
        </div>
      </ng-container>

      <!-- Matrículas (nova linha) -->
      <input type="text" formControlName="retorno_matricula" class="review-input" [placeholder]="'Matrícula 1' | translate"
        style="width: 95%;" />
      <input type="text" formControlName="retorno_matricula1" class="review-input" [placeholder]="'Matrícula 2' | translate"
        style="width: 95%;" />
      <input type="text" formControlName="retorno_matricula2" class="review-input" [placeholder]="'Matrícula 3' | translate"
        style="width: 95%;" />

      <!-- Especialidades (nova linha) -->
      <input type="text" formControlName="retorno_esp1" class="review-input" [placeholder]="'Especialidade 1' | translate"
        style="width: 95%;" />
      <input type="text" formControlName="retorno_esp2" class="review-input" [placeholder]="'Especialidade 2' | translate"
        style="width: 95%;" />
      <input type="text" formControlName="retorno_esp3" class="review-input" [placeholder]="'Especialidade 3' | translate"
        style="width: 95%;" />

      <!-- Endereço e Localidade (nova linha) -->
      <input type="text" formControlName="retorno_direccion" class="review-input" [placeholder]="'Endereço' | translate"
        style="grid-column: span 2; width: 95%;" />
      <input type="text" formControlName="retorno_localid" class="review-input" [placeholder]="'Localidade' | translate"
        style="width: 95%;" />
    </div>
  </div>
</div>

<!-- Modal Pesquisa de Médico -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModalMedicoOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Pesquisar médico por similaridade' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModalMedico()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="flex form filtros">
          <div class="form-group filtro" style="width: 100%;">
            <label>{{ 'Médico Selecionado' | translate}}: <strong>{{ medicoSelecionadoNome }}</strong> </label>
            <label>{{ 'Matrícula' | translate}}: <strong>{{ matriculaSelecionada }}</strong></label>
            <input type="text" class="form-control" [(ngModel)]="pesquisaMedico" (input)="filtrarMedicos()" (keydown.shift.o)="openCombo($event)" (keydown.enter)="confirmarSelecaoCombo($event)" (keydown.ArrowDown)="openCombo($event)" [placeholder]="'Pesquisar médico...' | translate" [ngModelOptions]="{standalone: true}">
            <small style="color: #666; font-size: 11px; display: block; margin-top: 4px;">{{ 'Pressione Shift + O ou a Seta para Baixo para abrir a lista' | translate }}</small>
            <small style="color: #666; font-size: 11px; display: block; margin-top: 2px;">{{ 'Use Alt + Número para selecionar rapidamente' | translate }}</small>
          </div>
        </div>
        
        <div class="flex form filtros" *ngIf="listaMedicosFiltrada && listaMedicosFiltrada.length > 0" style="margin-top: 15px;">
          <div class="form-group filtro" style="width: 100%;">
            <select class="form-control" size="12" [(ngModel)]="medicoSelecionadoCombobox" [ngModelOptions]="{standalone: true}" (click)="onMedicoClick($event)" (keydown.enter)="confirmarSelecaoCombo($event)" (keydown.ArrowDown)="openCombo($event)">
              <option value="" disabled selected>{{ 'Selecione um médico da lista...' | translate }}</option>
              <option *ngFor="let med of listaMedicosFiltrada; let i = index" [value]="i">{{ i }} - {{ med.name }}<ng-container *ngIf="!med.isNotFoundItem"> - {{ 'Matr.' | translate }} {{ med.matricula }} - {{ med.especialidade }}</ng-container></option>
            </select>
          </div>
        </div>
        <div *ngIf="listaMedicosFiltrada?.length === 0" class="text-center" style="color: #999; padding: 10px; margin-top: 15px;">
          {{ 'Nenhum médico encontrado.' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>